<template>
    <div>
        <div class="language-switcher" v-on:click="switchLanguage" :title="$t('change-language')">
            {{locales[$i18n.locale==='ua'? 'de' : 'ua']}}
        </div>
        <div class="info" v-on:click="showInfo" v-if="$route.path !== '/about/'" :title="$t('info')">
            <i class="fa fa-info"></i>
        </div>
        <div class="home" v-on:click="showHome" v-if="$route.path !== '/'" :title="$t('home')">
            <i class="fa fa-home"></i>
        </div>
    </div>
</template>

<script>
    import supportedLocales from '../config/supported-locales';
    import i18n from '../i18n';
    import router from '../router';


    export default {
        name: 'LanguageSwitcher',
        data: () => ({locales: supportedLocales}),
        methods: {
            switchLanguage: () => {
                i18n.locale = i18n.locale === 'ua' ? 'de' : 'ua';
                document.title = i18n.t('ziesel');
            },
            showInfo: () => {
                if (router.currentRoute.path !== '/about/') {
                    router.push('/about/');
                }
            },
            showHome: () => {
                if (router.currentRoute.path !== '/') {
                    router.push('/');
                }
            },
        }
    };
</script>
<style>
    .language-switcher {
        position: absolute;
        z-index: 100;
        right: 5px;
        top: 5px;
        border: 2px solid;
        border-radius: 50%;
        cursor: pointer;
        line-height: 44px;
        height: 44px;
        width: 44px;
        text-align: center;
        color: black;
        box-sizing: content-box;
    }

    .info, .home {
        position: absolute;
        z-index: 100;
        left: 5px;
        top: 5px;
        border: 2px solid;
        border-radius: 50%;
        cursor: pointer;
        line-height: 44px;
        height: 44px;
        width: 44px;
        text-align: center;
        color: black;
        box-sizing: content-box;
        vertical-align: center;
    }

    .language-switcher:hover, .info:hover, .home:hover {
        color: grey;
    }
</style>